import React, { ReactElement } from 'react';

import {
  Container,
  List,
  ListItem,
  Paragraph,
  Text,
} from '@constellation/core';
import NeedHelpWrapper from 'components/needHelpWrapper/NeedHelpWrapper';
import { Accordion } from 'components/tagging';

import { ACCORDION_EVENTS } from '../../../constants/analytics.constants';
import getLabel from '../../../utils/getLabel';

// This component will render when the user is not a full power signatory
function NeedHelp(): ReactElement {
  return (
    <Container padding="none">
      <NeedHelpWrapper>
        <Accordion
          label={getLabel('needHelp.bankMandateInstruction.title')}
          variation="standalone"
          marginBottom="02"
          eventAction={ACCORDION_EVENTS.BANK_MANDATE_INSTRUCTIONS}
        >
          <Paragraph size="s2" marginBottom="03">
            {getLabel('needHelp.bankMandateInstruction.content_1')}
          </Paragraph>

          <Paragraph size="s2" marginBottom="01">
            {getLabel('needHelp.bankMandateInstruction.list.header')}
          </Paragraph>
          <List marginBottom="none" marginLeft="02">
            {getLabel('needHelp.bankMandateInstruction.list.listItems').map(
              ({ label, content }) => (
                <ListItem key={label}>
                  <Text>
                    <strong>{label}</strong>
                    <br />
                  </Text>
                  <Text>{content}</Text>
                </ListItem>
              ),
            )}
          </List>
        </Accordion>
        <Accordion
          label={getLabel('needHelp.findBankMandate.title')}
          eventAction={ACCORDION_EVENTS.INSIDE_BANK_MANDATE}
          variation="standalone"
          marginBottom="02"
        >
          <Paragraph size="s2" marginBottom="none">
            {getLabel('needHelp.findBankMandate.content_1')}
          </Paragraph>
        </Accordion>
      </NeedHelpWrapper>
    </Container>
  );
}

export default NeedHelp;
